function returnTime(dateTime) {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const date = new Date(dateTime)
  return date.toLocaleString('fa-IR', { timeZone: userTimezone })
}
export default returnTime
